import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import PropTypes from 'prop-types';

function ModalAlert(props) {
    const {
        onHide,
        onSave,
        title,
        bodyText,
        cancelButtonText,
        confirmButtonText,
        showCancelButton,
    } = props;

    return (
        <Modal
            show={true}
            onHide={onHide}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="m-0 p-0">
                    <Col lg="12" className="m-0 p-0">
                        {bodyText}
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
            {
                showCancelButton &&
                <Button variant="secondary" onClick={onHide}>
                    {cancelButtonText}
                </Button>
            }
                <Button variant="primary" onClick={onSave}>
                    {confirmButtonText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ModalAlert.propTypes = {
    onHide: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    bodyText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    cancelButtonText: PropTypes.string.isRequired,
    confirmButtonText: PropTypes.string.isRequired,
    showCancelButton: PropTypes.bool,
};

ModalAlert.defaultProps = {
    cancelButtonText: "Tidak",
    confirmButtonText: "Ya",
    showCancelButton: true,
};

export default ModalAlert;